import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import UpdateModal from './UpdateModal';
import { useDispatch, useSelector } from 'react-redux';
import { FaEdit } from 'react-icons/fa';
import { AiFillDelete } from 'react-icons/ai';
import Loader from '../../../Shared/Loader';
import { format } from 'date-fns';
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { useRef } from 'react';


const BankDepositField = ({ }) => {
    const userAc = useSelector((state) => state.user.user);
    const { register, handleSubmit, reset, watch, formState: { errors } } = useForm();
    const [bankDeposits, setBankDeposits] = useState([]);
    const [updateBankDeposit, setUpdateBankDeposit] = useState(null);
    const [bankAccounts, setBankAccounts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isExpend, setIsExpend] = useState(false);
    const [searchResult, setSearchResult] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [isAccountSearching, setIsAccountSearching] = useState(false);
    const [accountText, setAccountText] = useState([]);
    const [accountSearch, setAccountSearch] = useState([]);
    const [sort, setSort] = useState('Newest First');
    const [isFilter, setIsFilter] = useState(false);
    const [currentAccount, setCurrentAccount] = useState([]);
    const [finalBalance, setFinalBalance] = useState(0);
    const [isCollect, setIsCollect] = useState(false);

    console.log(bankDeposits);
    const sortRef = useRef('');
    const accountNoRef = useRef('');
    const nameRef = useRef('');




    const handleSort = () => {
        const sortValue = sortRef.current.value;
        if (sortValue === "Oldest First") {
            setSort("Oldest First")
        } else {
            setSort("Newest First")
        }
    }
    const date = new Date();
    const today = format(date, "yyyy-MM-dd");

    // useEffect(() => {
    //     fetch('https://servers.thakurgaonexpress.com/rupkotha/getbankdeposits')
    //         .then(res => res.json())
    //         .then(data => {
    //             if (sort !== "Oldest First") {
    //                 setBankDeposits(data)
    //             } else {
    //                 const sorted = data.sort(function (a, b) {
    //                     return (a?.date > b?.date) ? 1 : ((a?.date < b?.date) ? -1 : 0);
    //                 });
    //                 setBankDeposits(sorted);
    //             }
    //             setLoading(false)
    //         })
    // }, [sort])
    const fetchData = () => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getbankdeposits')
            .then(res => res.json())
            .then(data => {
                if (sort !== "Oldest First") {
                    setBankDeposits(data);
                } else {
                    const sorted = data.sort(function (a, b) {
                        return (a?.date > b?.date) ? 1 : ((a?.date < b?.date) ? -1 : 0);
                    });
                    setBankDeposits(sorted);
                }
            });
    };

    useEffect(() => {
        fetchData(); // Fetch data when the component mounts
    }, [sort]);

    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getbankaccounts')
            .then(res => res.json())
            .then(data => {
                const filter = data?.filter(eh => eh?.status === "Active")
                setBankAccounts(filter);
                setLoading(false)
            })
    }, [])

    if (loading) {
        return <Loader />
    }

    // const onSubmit = data => {
    //     const currentDate = new Date(data.date);
    //     const formattedDate = format(currentDate, 'MMM-yyyy');
    //     const bankdeposit = parseInt(data.amount);
    //     const accountno = accountNoRef.current.value;
    //     const name = nameRef.current.value;
    //     const user = userAc?.email.split('@')[0];

    //     const newData = { ...data, accountno, name, month: formattedDate, bankdeposit, user }
    //     fetch('https://servers.thakurgaonexpress.com/rupkotha/addbankdeposit', {
    //         method: 'POST',
    //         headers: {
    //             'content-type': 'application/json'
    //         },
    //         body: JSON.stringify(newData),
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             toast.success('Bank Deposit Added')
    //             reset();
    //             setTimeout(() => { window.location.reload(); }, 3000);
    //         })

    // }

    const onSubmit = data => {
        const currentDate = new Date(data.date);
        const formattedDate = format(currentDate, 'MMM-yyyy');
        const bankdeposit = parseInt(data.amount);
        const accountno = accountNoRef.current.value;
        const name = nameRef.current.value;
        const user = userAc?.email.split('@')[0];

        const newData = { ...data, accountno, name, month: formattedDate, bankdeposit, user }
        // Function to make the fetch request to add an expense
        const addBankDeposit = () => {
            fetch('https://servers.thakurgaonexpress.com/rupkotha/addbankdeposit', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(newData),
            })
                .then(res => res.json())
                .then(data => {
                    toast.success('Bank Deposit Added');
                    reset();
                    fetchData();
                    setIsExpend(false);
                    setCurrentAccount(null);
                });
        };

        // Call the function to add the expense
        addBankDeposit();
    };

    const handleDeleteBankDeposit = (id) => {
        const proceed = window.confirm('Are You Sure Want To Delete')
        if (proceed) {
            fetch(`https://servers.thakurgaonexpress.com/rupkotha/getbankdeposit/${id}`, {
                method: 'DELETE'
            })
                .then(res => res.json())
                .then(data => {
                    toast.success('Delete Successful')
                    setUpdateBankDeposit(null);
                    fetchData();
                })
        }
    };

    const handleFilteredData = e => {
        e.preventDefault();
        const startDate = e.target.startDate.value;
        const endDate = e.target.endDate.value;
        const name = e.target.category.value;
        const sortBy = e.target.sort.value;
        const url = `https://servers.thakurgaonexpress.com/rupkotha/filteredbankdeposits?startDate=${startDate}&endDate=${endDate}`
        fetch(url)
            .then(res => res.json())
            .then(data => {
                if (name === "All") {
                    if (sortBy !== "Oldest First") {
                        setBankDeposits(data);
                    } else {
                        const sorted = data.sort(function (a, b) {
                            return (a?.date > b?.date) ? 1 : ((a?.date < b?.date) ? -1 : 0);
                        });
                        setBankDeposits(sorted);
                    }
                } else {

                    if (sortBy !== "Oldest First") {
                        const filteredbankdeposits = data.filter(bankdeposit => bankdeposit.name === name);
                        setBankDeposits(filteredbankdeposits);
                    } else {
                        const filteredbankdeposits = data.filter(bankdeposit => bankdeposit.name === name);
                        const sorted = filteredbankdeposits.sort(function (a, b) {
                            return (a?.date > b?.date) ? 1 : ((a?.date < b?.date) ? -1 : 0);
                        });
                        setBankDeposits(sorted);
                    }
                }
                setIsFilter(true);
            })
    }

    const handleUpdateBankDeposit = (bankdeposit) => {
        setUpdateBankDeposit(bankdeposit);
    }

    const handleSearchResult = (event) => {
        const searchText = event.target.value.toLowerCase();
        const match = bankDeposits.filter(bankdeposit => bankdeposit.name.toLowerCase().includes(searchText)
            || bankdeposit.purpose.toLowerCase().includes(searchText) || bankdeposit.amount.toLowerCase().includes(searchText)
            || bankdeposit.date.toLowerCase().includes(searchText) || bankdeposit.invoice.toLowerCase().includes(searchText) ||
            bankdeposit.accountno.toLowerCase().includes(searchText));
        setSearchResult(match);
        setIsSearching(true);
    }

    const handleSearchBankDeposit = (event) => {
        setAccountText(event.target.value)
        const match = bankAccounts.filter(bankaccount => bankaccount.name.toLowerCase().includes(accountText)
            || bankaccount.name.includes(accountText) || bankaccount.name.toUpperCase().includes(accountText));
        setAccountSearch(match);
        setIsAccountSearching(true);
    }

    const handleSelectBankAccount = (bankAccount) => {
        const opening = parseFloat(bankAccount?.opening)
        const url = `https://servers.thakurgaonexpress.com/rupkotha/filteredaccount?accountno=${bankAccount.accountno}`
        fetch(url)
            .then(res => res.json())
            .then(data => {
                const balance = opening + data?.defaultTotalDeposit - data?.defaultTotalWithdraw;
                setCurrentAccount({ ...bankAccount, balance });
            })
        setIsAccountSearching(false)
        setAccountText('');
    }

    const handleFinalBalance = (event) => {
        const currentBalance = currentAccount?.balance;
        const balance = currentBalance + parseInt(event?.target?.value);
        setFinalBalance(balance);
        setIsCollect(true);
    }

    const handleApprove = (bankdeposit) => {
        const approvedBy = userAc?.email.split('@')[0];
        fetch(`https://servers.thakurgaonexpress.com/rupkotha/getbankdeposit/${bankdeposit._id}`, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ approvedBy })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                toast('Bank Deposit Approved');
                fetchData();
            })
    }

    const totalAmount = !isSearching ? bankDeposits.reduce((total, currentValue) => total + parseInt(currentValue?.amount), 0)
        : searchResult.reduce((total, currentValue) => total + parseInt(currentValue?.amount), 0);
    return (
        <div>
            <div className={`${isExpend ? 'shadow-2xl' : ''} px-12 pb-5 mt-5 text-xs`}>
                <div className='text-right'><button onClick={() => setIsExpend(!isExpend)} className='btn btn-sm btn-error text-white'>{isExpend === true ? <AiOutlineMinus className='text-sm font-bold' /> : <AiOutlinePlus className='text-sm font-bold' />}Add Bank Deposit</button></div>
                <div className={`${isExpend === true ? "" : "hidden"}`}>
                    <div class="form-control w-full max-w-xs mt-5 col-span-2">
                        <div class="form-control w-full">
                            <input onChange={handleSearchBankDeposit} value={accountText} type="text" placeholder="Search Bank Account" class="rounded-lg text-xs bg-white p-3 placeholder-gray-400  text-center  focus:border-blue-500 focus:outline-none w-full max-w-xs" />
                        </div>
                        <div style={isAccountSearching ? {} : { visibility: 'hidden' }} className={`grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 bg-gray-200 p-2 ${isAccountSearching ? 'h-16' : "h-8"} w-full overflow-auto`}>
                            {
                                isAccountSearching ? accountSearch.map(account =>
                                    <label for="update-modal" onClick={() => handleSelectBankAccount(account)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{account?.name}</label>) :
                                    bankAccounts.map(account =>
                                        <label for="update-modal" onClick={() => handleSelectBankAccount(account)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{account?.name}</label>)
                            }
                        </div>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)} className={`container text-xs grid grid-cols-1 lg:grid-cols-3 gap-1 justify-center items-center`}>
                        <div class="form-control w-full max-w-xs">
                            <label class="label">
                                <span class="label-text text-sm">Account No</span>
                            </label>
                            <input disabled ref={accountNoRef} value={currentAccount?.accountno} type="text" class="rounded-lg bg-white p-4 text-textPrimary placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs" required />
                        </div>
                        <div class="form-control w-full max-w-xs">
                            <label class="label">
                                <span class="label-text text-sm">Bank Account Name</span>
                            </label>
                            <input disabled ref={nameRef} value={currentAccount?.name} type="text" class="rounded-lg bg-white p-4 text-textPrimary placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs" required />
                        </div>
                        <div class="form-control w-full max-w-xs">
                            <label class="label">
                                <span class="label-text text-sm">Previews Balance</span>
                            </label>
                            <input disabled type="number" value={currentAccount?.balance} class="rounded-lg bg-white p-4 text-textPrimary placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs" required />
                        </div>
                        <div class="form-control w-full max-w-xs">
                            <label class="label">
                                <span class="label-text text-sm">Deposit Amount</span>
                            </label>
                            <input {...register("amount")} onChange={handleFinalBalance} type="number" placeholder="Type Amount Here" class="rounded-lg bg-white p-4 text-textPrimary placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs" required />
                        </div>
                        <div class="form-control w-full max-w-xs">
                            <label class="label">
                                <span class="label-text text-sm">Final Balance</span>
                            </label>
                            <input disabled type="number" value={isCollect === true ? finalBalance : currentAccount?.balance} class="rounded-lg bg-white p-4 text-textPrimary placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs" required />
                        </div>
                        <div class="form-control w-full max-w-xs">
                            <label class="label">
                                <span class="label-text text-sm">Select Date</span>
                            </label>
                            <input {...register("date")} type="date" defaultValue={today} placeholder="Date" class="rounded-lg bg-white p-4 text-textPrimary placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs" required />
                        </div>
                        <div class="form-control w-full max-w-xs">
                            <label class="label">
                                <span class="label-text text-sm">Invoice No</span>
                            </label>
                            <input {...register("invoice")} type="text" placeholder="Type Invoice No Here" class="rounded-lg bg-white p-4 text-textPrimary placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs" required />
                        </div>


                        <div class="form-control w-full max-w-xs">
                            <label class="label">
                                <span class="label-text text-sm">Remarks</span>
                            </label>
                            <input {...register("purpose")} type="text" placeholder="Type Remarks Here" class="rounded-lg bg-white p-4 text-textPrimary placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs" required />
                        </div>
                        <div class="form-control w-full max-w-xs">
                            <label class="label">
                                <span class="label-text text-sm">Status</span>
                            </label>
                            <select style={{ padding: '18px' }} {...register("status")} defaultValue='' class="rounded-lg bg-white text-textPrimary placeholder-gray-400 w-full max-w-xs" required>
                                <option selected>Active</option>
                                <option>Inactive</option>
                            </select>
                        </div>
                        <input disabled={!userAc?.addBankDeposit | !currentAccount.name} type="submit" value='Add Bank Deposit' className='btn w-full lg:w-60 bg-primary text-white mt-2 lg:mt-9' />
                    </form>
                </div>
            </div>
            <div className='text-xs mx-2 shadow-2xl p-2 lg:p-5'>
                <div className={`${isExpend === false ? "" : "hidden"}`}>
                    <div className='flex justify-center lg:justify-end items-center'>
                        <form onSubmit={handleFilteredData} className='mt-12 flex flex-col lg:flex-row justify-center items-right'>
                            <div class="form-control w-full lg:w-40 max-w-xs lg:mr-2">
                                <label class="label">
                                    <span class="label-text">Starting Date</span>
                                </label>
                                <input name='startDate' defaultValue={today} type="date" class="input text-xs input-bordered w-full max-w-xs" required />
                            </div>
                            <div class="form-control w-full lg:w-40 max-w-xs lg:mr-2">
                                <label class="label">
                                    <span class="label-text">End Date</span>
                                </label>
                                <input name='endDate' defaultValue={today} type="date" class="input text-xs input-bordered w-full max-w-xs" required />
                            </div>
                            <div class="form-control w-full lg:w-60 max-w-xs lg:mr-2">
                                <label class="label">
                                    <span class="label-text">Account</span>
                                </label>
                                <select style={{ padding: '' }} {...register("category")} defaultValue='' class="rounded-lg text-textPrimary text-xs select select-bordered w-full max-w-xs" required>
                                    <option selected>All</option>
                                    {
                                        bankAccounts.map(account => <option>{account?.name}</option>)
                                    }
                                </select>
                            </div>
                            <div class={`form-control w-full lg:w-40 max-w-xs lg:mr-2`}>
                                <label class="label">
                                    <span class="label-text">Short By</span>
                                </label>
                                <select style={{ padding: '' }} {...register("sort")} defaultValue='' class="rounded-lg text-textPrimary text-xs select select-bordered w-full max-w-xs" required>
                                    <option selected>Newest First</option>
                                    <option>Oldest First</option>
                                </select>
                            </div>

                            <input type='submit' value='Search' className='btn btn-md btn-error text-white mt-4 lg:mt-9 lg:ml-2' />
                        </form>
                    </div>
                    <div className='flex justify-end items-center my-8 lg:my-4'>
                        <div class="form-control w-full lg:w-60">
                            <input onChange={handleSearchResult} type="text" placeholder="Search Bank Deposit" class="input text-xs mx-auto input-bordered bg-white input-error w-full max-w-xs" />
                        </div>
                    </div>
                    <div className={`h-8 ${isFilter === false ? "flex justify-between items-center" : "text-right"}`}>
                        <div className={`form-control w-40 max-w-xs lg:mr-2 ${isFilter === true ? "hidden" : ""}`}>
                            <label class="label">
                                <span class="label-text">Short By</span>
                            </label>
                            <select ref={sortRef} style={{ padding: '' }} onChange={handleSort} defaultValue='' class="rounded-lg text-textPrimary text-xs select select-bordered w-full max-w-xs" required>
                                <option selected>Newest First</option>
                                <option>Oldest First</option>
                            </select>
                        </div>
                        <div className='text-right'>
                            <ReactHtmlTableToExcel
                                id="test-table-xls-button"
                                className="btn btn-error text-white btn-xs mt-10 lg:mt-0"
                                table="table-to-xls"
                                filename="bankdeposits-table"
                                sheet="bankdeposits"
                                buttonText="Export to exel" />
                        </div>
                    </div>
                    {
                        bankDeposits?.length ? <div class="overflow-x-auto mt-8">
                            <table id="table-to-xls" class="table w-1/2 mx-auto text-xs">
                                <thead className='text-center'>
                                    <tr>
                                        <th className='bg-primary text-white normal-case'>SL</th>
                                        <th className='bg-primary text-white normal-case'>Date</th>
                                        <th className='bg-primary text-white normal-case'>Account No</th>
                                        <th className='bg-primary text-white normal-case'>Bank Account Name</th>
                                        <th className='bg-primary text-white normal-case'>Invoice No</th>
                                        <th className='bg-primary text-white normal-case'>Amount</th>
                                        <th className='bg-primary text-white normal-case'>Purpose</th>
                                        <th className='bg-primary text-white normal-case'>Status</th>
                                        <th className='bg-primary text-white normal-case'>Added By</th>
                                        <th className='bg-primary text-white normal-case'>Approved By</th>
                                        <th className='bg-primary text-white normal-case'>Edit</th>
                                        <th className='bg-primary text-white normal-case'>Delete</th>
                                    </tr>
                                </thead>
                                <tbody className='text-center'>
                                    {
                                        isSearching ? searchResult.map((bankdeposit, index) => <tr className='hover'>
                                            <td>{index + 1}</td>
                                            <td>{bankdeposit?.date}</td>
                                            <td>{bankdeposit?.accountno}</td>
                                            <td>{bankdeposit?.name}</td>
                                            <td>{bankdeposit?.invoice}</td>
                                            <td>{bankdeposit?.amount}</td>
                                            <td>{bankdeposit?.purpose}</td>
                                            <td> <button className={`btn btn-xs normal-case ${bankdeposit?.status === 'Active' ? 'bg-green-700' : 'bg-danger'}`}>{bankdeposit?.status}</button> </td>
                                            <td><button className='btn btn-xs btn-primary text-white normal-case'>{bankdeposit?.user ? bankdeposit?.user : "User"}</button></td>
                                            {userAc.approvalBankDeposit ? <td>{bankdeposit?.approvedBy ? <button className='btn btn-xs btn-success text-white normal-case'>{bankdeposit?.approvedBy}</button> : <button onClick={() => handleApprove(bankdeposit)} className='btn btn-xs btn-secondary text-white normal-case'>Approve</button>}</td> :
                                                <td>{bankdeposit.approvedBy ? <button className='btn btn-xs btn-success text-white normal-case'>{bankdeposit.approvedBy}</button> : <button className='btn btn-xs btn-error text-white'>Not Approved</button>}</td>}
                                            {userAc?.editBankDeposit && <td><button><label for="update-modal" onClick={() => handleUpdateBankDeposit(bankdeposit)} className='text-xl text-green-700 cursor-pointer'><FaEdit /></label></button></td>}
                                            {userAc?.deleteBankDeposit && <td><button onClick={() => handleDeleteBankDeposit(bankdeposit._id)} className='text-xl text-danger'><AiFillDelete /></button></td>}
                                        </tr>) : bankDeposits.map((bankdeposit, index) => <tr className='hover'>
                                            <td>{index + 1}</td>
                                            <td>{bankdeposit?.date}</td>
                                            <td>{bankdeposit?.accountno}</td>
                                            <td>{bankdeposit?.name}</td>
                                            <td>{bankdeposit?.invoice}</td>
                                            <td>{bankdeposit?.amount}</td>
                                            <td>{bankdeposit?.purpose}</td>
                                            <td> <button className={`btn btn-xs normal-case ${bankdeposit?.status === 'Active' ? 'bg-green-700' : 'bg-danger'}`}>{bankdeposit?.status}</button> </td>
                                            <td><button className='btn btn-xs btn-primary text-white normal-case'>{bankdeposit?.user ? bankdeposit.user : "User"}</button></td>
                                            {userAc.approvalBankDeposit ? <td>{bankdeposit?.approvedBy ? <button className='btn btn-xs btn-success text-white normal-case'>{bankdeposit?.approvedBy}</button> : <button onClick={() => handleApprove(bankdeposit)} className='btn btn-xs btn-secondary text-white normal-case'>Approve</button>}</td> :
                                                <td>{bankdeposit.approvedBy ? <button className='btn btn-xs btn-success text-white normal-case'>{bankdeposit.approvedBy}</button> : <button className='btn btn-xs btn-error text-white'>Not Approved</button>}</td>}
                                            {userAc?.editBankDeposit && <td><button><label for="update-modal" onClick={() => handleUpdateBankDeposit(bankdeposit)} className='text-xl text-green-700 cursor-pointer'><FaEdit /></label></button></td>}
                                            {userAc?.deleteBankDeposit && <td><button onClick={() => handleDeleteBankDeposit(bankdeposit._id)} className='text-xl text-danger'><AiFillDelete /></button></td>}
                                        </tr>)
                                    }
                                </tbody>
                                <tfoot className='text-center'>
                                    <tr>
                                        <th className='bg-primary text-white normal-case'></th>
                                        <th className='bg-primary text-white normal-case'></th>
                                        <th className='bg-primary text-white normal-case'></th>
                                        <th className='bg-primary text-white normal-case'></th>
                                        <th className='bg-primary text-white normal-case'>Total</th>
                                        <th className='bg-primary text-white normal-case'>{totalAmount}</th>
                                        <th className='bg-primary text-white normal-case'></th>
                                        <th className='bg-primary text-white normal-case'></th>
                                        <th className='bg-primary text-white normal-case'></th>
                                        <th className='bg-primary text-white normal-case'></th>
                                        <th className='bg-primary text-white normal-case'></th>
                                        <th className='bg-primary text-white normal-case'></th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div> : ""
                    }
                </div>
            </div>
            {
                updateBankDeposit && <UpdateModal fetchData={fetchData} setUpdateBankDeposit={setUpdateBankDeposit} updateBankDeposit={updateBankDeposit}></UpdateModal>
            }
        </div>
    );
};

export default BankDepositField;